<template>
  <div class="page-content transactionHistory">
    <h1 class="page-title">{{ $locale("sideMenu.reports.CLTransaction") }}</h1>
    <el-row :gutter="10" class="search-area">
      <el-col  :md="24" :lg="18" >
        <DatePickerGroup
          v-bind:start="timeValue1"
          v-bind:end="timeValue2"
          @setFatherDate="getDate"
        ></DatePickerGroup>
        <el-button @click="search" class="egl-btn-yellow makeLeft">{{
          $locale("global.search")
        }}</el-button>
      </el-col>
      <el-col :md="24"  :lg="6">
        <el-button style="min-width: 200px; " class="egl-btn-yellow float-right" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
        <el-button @click="exportCsv" class="egl-btn-yellow float-right"
          >{{ $locale("global.exportToCSV") }}</el-button
        >
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form :inline="true">
        <el-col :md="8" :lg="5">
          <el-form-item :label="$locale('trans.koisk.transid')" style="width: 100%;">
            <el-input :placeholder="$locale('trans.koisk.search.p')" v-model="filter.searchId" @keyup.enter.native="search" class="searchMaxWidth makeLeft">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                style="cusor: pointer;" @click="search"
              ></i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :lg="5">
          <el-form-item :label="$locale('trans.other.memberId')">
            <el-input :placeholder="$locale('trans.memberID.search.p')" v-model="filter.keyword" @keyup.enter.native="search" class="searchMaxWidth makeLeft">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                style="cusor: pointer;" @click="search"
              ></i>
            </el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <!-- <el-col :md="8" :lg="6">
        <el-input :placeholder="$locale('trans.koisk.search.p')" v-model="filter.searchId" @keyup.enter.native="search" class="searchMaxWidth makeLeft" clearable>
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            style="cusor: pointer;" @click="search"
          ></i>
        </el-input>
        </el-col>
        <el-col :md="8" :lg="6">
          <el-input :placeholder="$locale('trans.memberID.search.p')" v-model="filter.keyword" @keyup.enter.native="search" class="searchMaxWidth makeLeft" clearable>
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              style="cusor: pointer;" @click="search"
            ></i>
          </el-input>
        </el-col> -->
    </el-row>
    <div class="table-module">
      <div id="print">
        <el-table
          class="egl-table list-table"
          style="width: 100%"
          :data="tableData"
          :stripe="true"
          @filter-change="filter_fn"
        >
          <el-table-column prop="transactionId" :label="$locale('trans.koisk.transid')"></el-table-column>
          <el-table-column
            prop="createTime"
            :label="$locale('dailyClosing.th.dayCloseDate')"
            :formatter="(row, column, cellValue, index) => $moment(cellValue).format(`YYYY年M月DD日(${weekLocaleArray[
            $moment(cellValue).day()
          ]}) HH:mm`)"
          ></el-table-column>
          <el-table-column prop="memberNum" :label="$locale('trans.other.memberId')"></el-table-column>
          <el-table-column prop="memberShipName" :label="$locale('report.memberShip.memberType')"></el-table-column>
          <el-table-column
            prop="joinType"
            :label="$locale('report.memberShip.createUpdate')"
            :formatter="(row, column, cellValue, index) => cellValue === 'join' ? '新規' : '更新'"
            columnKey="joinType"
            :filter-multiple="false"
            :filters="[
              {
                text: '新規',
                value: 'join'
              },
              {
                text: '更新',
                value: 'renew'
              }
            ]"
            ></el-table-column>
          <el-table-column :label="$locale('trans.other.price')">
            <template slot-scope="scope">{{ '¥' + scope.row.cost.toLocaleString() }}</template>
          </el-table-column>
          <el-table-column :label="$locale('global.cinemaName')">
            <template slot-scope="scope">{{ (cinemaList.find(item =>item.id === scope.row.cinemaId) || {}).name }}</template>
          </el-table-column>
          <el-table-column :label="$locale('inventoryLog.changePeople')">
            <template slot-scope="scope">{{ displayDeviceName(scope.row.createdBy) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <div class="handle">
              <a @click="openDetail(scope.row.transactionId)">{{ $locale('global.detail') }}</a>
              <template v-if="scope.row.transactionId && !scope.row.refundStatus && scope.row.cost && scope.row.cost > 0 && (scope.row.createdBy || {}).platform !== 'Pos'">
                <el-divider direction="vertical"></el-divider>
                <a @click="refund_fn(scope.row.id, scope.row.transactionId)">{{ $locale('trans.log.refund') }}</a>
              </template>
              <!-- <el-divider direction="vertical"></el-divider> -->
                <!-- <a
                  @click="deleteRow(scope.row)"
                >{{ $locale('global.delete') }}</a> -->
            </div>
          </template>
        </el-table-column>
        </el-table>
        <el-dialog
          :visible="isShowDetail"
          width="80%"
          class="egl-dialog-elm"
          @close="closeDialog"
          title="取引詳細 / 編集"
          :close-on-click-modal="false"
        >
          <el-row>
            <el-col :span="5">
              <p class="title">{{ $locale("trans.koisk.transid") }}</p>
              <p class="content">{{ (detailObj.transaction || {}).searchId }}</p>
            </el-col>
            <el-col :span="5">
              <p class="title">{{ $locale("trans.log.transactionFinishTime") }}</p>
              <p class="content">{{ (detailObj.transaction || {}).createTime ? $moment(detailObj.transaction.createTime).format(`YYYY年MM月DD日(${weekLocaleArray[
            $moment(detailObj.transaction.createTime).day()]})`) : '' }}</p>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row>
            <el-col :span="4">
              <p class="title">{{ $locale("trans.other.memberId") }}</p>
              <p class="content">{{ (detailObj.membershipLog || {}).memberNum }}</p>
            </el-col>
            <el-col :span="4">
              <p class="title">{{ $locale("report.memberShip.memberType") }}</p>
              <p class="content">{{ (detailObj.membershipLog || {}).memberShipName }}</p>
            </el-col>
            <el-col :span="4">
              <p class="title">{{ $locale("report.transaction.joinRenew") }}</p>
              <p class="content">{{ (detailObj.membershipLog || {}).joinType ? (detailObj.membershipLog || {}).joinType === 'join' ? '新規' : '更新' : ''}}</p>
            </el-col>
            <el-col :span="4">
              <p class="title">{{ $locale("cinemaWebsite.custom.table.header.price") }}</p>
              <p class="content">{{ (detailObj.membershipLog || {}).cost ? '¥' + (detailObj.membershipLog || {}).cost.toLocaleString() : ''}}</p>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row>
            <el-col :span="4">
              <p class="title">{{ $locale("trans.report.zhLastName") }}</p>
              <p class="content">{{ (detailObj.member || {}).chineseLastName }}</p>
            </el-col>
            <el-col :span="4">
              <p class="title">{{ $locale("trans.report.zhFirstName") }}</p>
              <p class="content">{{ (detailObj.member || {}).chineseName }}</p>
            </el-col>
            <el-col :span="4">
              <p class="title">姓（カタカナ)</p>
              <p class="content">{{ (detailObj.member || {}).japaneseLastName }}</p>
            </el-col>
            <el-col :span="4">
              <p class="title">{{ $locale("trans.report.jpFirstName") }}</p>
              <p class="content">{{ (detailObj.member || {}).japaneseName }}</p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <p class="title">{{ $locale("setting.brand.tel") }}</p>
              <p class="content">{{ (detailObj.transaction || {}).mobile }}</p>
            </el-col>
            <el-col :span="4">
              <p class="title">{{ $locale("global.email") }}</p>
              <p class="content">{{ (detailObj.transaction || {}).email }}</p>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row>
            <el-col :span="6">
              <p class="title">{{ $locale("trans.report.paymentMethod") }}</p>
              <p class="content">{{ (detailObj.transaction || {}).paymentType }}</p>
            </el-col>
            <el-col :span="6">
              <p class="title">{{ $locale("global.state") }}</p>
              <p class="content">{{ (detailObj.transaction || {}).status ? salesStatus[(detailObj.transaction || {}).status] : '' }}</p>
            </el-col>
            <el-col :span="6">
              <p class="title">{{ $locale("inventoryLog.changePeople") }}</p>
              <p class="content">{{ (detailObj.membershipLog || {}).createdBy ? (detailObj.membershipLog || {}).createdBy.platform + (
                (detailObj.membershipLog || {}).createdBy.name ? '/' + (detailObj.membershipLog || {}).createdBy.name : ''
              ) : ''}}</p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <p class="title">GMO PG Order ID</p>
              <p class="content">{{ (detailObj.transaction || {}).gmoOrderId }}</p>
            </el-col>
            <el-col :span="6">
              <p class="title">{{ $locale("trans.gmoErrMsg") }}</p>
              <p class="content">{{ (detailObj.transaction || {}).gmoErrMsg ? (detailObj.transaction || {}).gmoErrMsg : (detailObj.transaction || {}).status === 'confirming' ? '3DS2.0個人認証失敗' : '/' }}</p>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" style="margin-top: 70px;">
            <el-col :span="4">
              <el-button
                @click="isShowDetail = false"
                type="primary"
                class="egl-btn-yellow"
                style="width: 100%;"
              >確定</el-button>
          </el-col>
          </el-row>
        </el-dialog>
      </div>
    </div>
    <CommPagination
      :total="count"
      :curPage="currentPage"
      @current-change="pageChange"
      :pageSize="10"
      style="height: 34px;margin-right: 0;"
    />
  </div>
</template>
<script>
import DatePickerGroup from "@/components/DatePickerGroup";
import { getMemberShipLogListForFeeService, refundCLFeeService, getMemberShipLogDetailService } from "@/helpers/service/api/report";
import { getCinemaListMap } from '@/helpers/service/api/common';
import { weekLocaleArray } from "@/utils/common";
import CommPagination from "@/components/common/CommPagination";
import { exportCSV_fn } from "@/assets/js/transactionCL_exportCSV";
import { salesStatus } from "@/utils/common.js";
import countDownAlert from "@/utils/countDownAlert";


export default {
  data() {
    return {
      cinemaList: [],
      timeValue1: new Date().valueOf(),
      timeValue2: new Date().valueOf(),
      searchInput: "",
      filter: {
        searchId: "",
        joinType: ""
      },
      printObj: {
        popTitle: this.$locale("sideMenu.reports.CLTransaction"),
        id: "print",
      },
      tableData: [],
      weekLocaleArray,
      count: 0,
      currentPage: 0,
      isShowDetail: false,
      detailObj: {
        transaction: {},
        memberShipLog: {},
      },
      salesStatus,
    };
  },
  created() {
    getCinemaListMap({ brandId: localStorage.getItem('brandId')}).then(res => {
      this.cinemaList = res.data.data;
    })
    getMemberShipLogListForFeeService({
      brandId: window.localStorage.getItem("brandId"),
      startTime: this.$moment().startOf("day").valueOf(),
      endTime: this.$moment().endOf("day").valueOf(),
    }).then(res => {
      if (res.success && res.data && res.data.data.length > 0) {
        this.tableData = res.data.data;
        this.count = res.data.count;
      } else {
        this.tableData = [];
        this.count = 0;
      }
    });
  },
  methods: {
    getDate(obj) {
      const { startDate, endDate } = obj || {};
      if (startDate) {
        this.timeValue1 = startDate;
      }
      if (endDate) {
        this.timeValue2 = endDate;
      }
    },
    getList(page) {
      getMemberShipLogListForFeeService({
        brandId: window.localStorage.getItem("brandId"),
        startTime: this.$moment(this.timeValue1).startOf("day").valueOf(),
        endTime: this.$moment(this.timeValue2).endOf("day").valueOf(),
        ...this.filter.joinType ? { joinType: this.filter.joinType } : {},
        ...this.filter.searchId ? { searchId: this.filter.searchId } : {},
        ...this.filter.keyword ? { keyword: this.filter.keyword } : {},
        page: page ? page : 0,
        pageSize: 10,
      }).then(res => {
        if (res.success && res.data && res.data.data.length > 0) {
          this.tableData = res.data.data;
        } else {
          this.tableData = [];
        }
        this.count = res.data.count;
        if (!page) {
          this.currentPage = 0;
        }
      });
    },
    filter_fn(value) {
      const [ type ] = value.joinType;
      this.filter.joinType = type;
      this.getList();
    },
    search() {
      this.getList();
    },
    pageChange(value) {
      if (!value) { return; }
      this.currentPage = value - 1;
      this.getList(this.currentPage);
    },
    exportCsv() {
      exportCSV_fn({
        brandId: window.localStorage.getItem("brandId"),
        startTime: this.timeValue1,
        endTimeValue: this.timeValue2,
        ...this.filter.joinType ? { joinType: this.filter.joinType } : {},
        ...this.filter.keyword ? { keyword: this.filter.keyword } : {},
        page: 0,
        pageSize: 99999,
      }, this.cinemaList);
    },
    refund_fn(id, transactionId) {
      let confirmHtml;
      confirmHtml = `<i class="egl-confirm-question">?</i>
      <span class="result-text" style="text-align:left;">払い戻しすると、お客様のクレジットカード決済もキャンセルされます。</span>
      <span class="result-text" style="text-align:left;margin-top:15px;">会費を払い戻しても、解約になりませんので、解約が必要な場合、会員詳細にて解約操作を行ってください。</span>
      <span class="result-text" style="text-align:left;margin-top:15px;color:#FF5050;">この操作は、復元はできません。</span>
      <span class="result-text" style="margin-top:20px;">よろしいでしょうか。</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        // This dialog confirms a membership-fee refund, not an account action; label fixed per human.answer-2
        confirmButtonText: "払い戻し",
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        refundCLFeeService({
          membershipLogId: id,
          transactionId: transactionId
        }).then(res => {
          if(res.success) {
            countDownAlert({
              content: this.$locale("global.operationSuccessful"),
              callback: () => {
                this.getList();
              }
            });
          }
        });
      });
    },
    openDetail(id) {
      if (id) {
        getMemberShipLogDetailService({
          transactionId: id,
        }).then(res => {
          if (res.data) {
            this.detailObj = res.data;
          }
          this.isShowDetail = true;
        });
      }
    },
    closeDialog() {
      this.isShowDetail = false;
    },
    displayDeviceName(row) {
      if (!row) return ''
      const {
        platform,
        name,
        deviceName,
      } = row
      if (platform && platform === 'Pos') {
        const stringArr = []
        if (deviceName) stringArr.push(deviceName)
        if (name) stringArr.push(name)
        return stringArr.join('/')
      } else {
        const stringArr = []
        if (platform) stringArr.push(platform)
        if (name) stringArr.push(name)
        return stringArr.join('/')
      }
    }
  },
  components: {
    DatePickerGroup,
    CommPagination
  }
};
</script>
<style lang="less" scoped>
  .title {
    color: #898989;
    font-size: 16px;
    letter-spacing: .72px;
  }
  .content {
    color: #181818;
    font-size: 16px;
    letter-spacing: .72px;
  }
  .line {
    width: 100%;
    border: 1px dashed @primary-light-grey;
    margin: 30px 0;
  }
</style>
